var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-container"},[_c('img',{staticStyle:{"position":"absolute","bottom":"0px","backgroud-color":"#f2f5f5","opacity":"0.6"},attrs:{"src":require("@/assets/dashboard-bg.svg")}})])
}]

export { render, staticRenderFns }